/**
 * Created by tdunham on 6/30/2017.
 */

import {Injectable}                     from "@angular/core";
import {HttpClient, HttpHeaders}        from "@angular/common/http";

import {AngularQuery}                   from "../query/angularquery";
import {League}                         from "./league";
import {Team}                           from './team';

import {Observable}                     from "rxjs";


@Injectable()
export class TeamService {

	/**
	 * Initialize the object.
	 *
	 * @param {HttpClient} http  Access to HTTP.
	 */
	constructor(protected http: HttpClient) {}


	/**
	 * Get the Division string array by the Sport code.
	 *
	 * @param code   The sport code value ("NFL", "MLB", etc.)
	 * @returns {Observable<Team>}  An Observable<Team> object or error.
	 */
	getDivision(code: string): Observable<string[]> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_TEAM_DIVISION, code);
		let url:string = query.getUrl();
		return this.http
			.get<string[]>(url);

	}


	/**
	 * Get the League objects by the Sport code.
	 *
	 * @param code   The sport code value ("NFL", "MLB", etc.)
	 * @returns {Observable<League[]>}  An Observable<League[]> object or error.
	 */
	getLeague(code: string): Observable<League[]> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_TEAM_LEAGUE);
		query.addParameter('code', code);
		let url:string = query.getUrl();
		return this.http
			.get<League[]>(url);

	}


	/**
	 * Get the Team object specified by the provided Angular ReST API ID.
	 *
	 * @param id       An Angular ReST API ID value from the "article" table.
	 * @returns {Observable<Team>}  An Observable<Team> object or error.
	 */
	getTeamByArticleId(id: number): Observable<Team> {

		let query:AngularQuery = new AngularQuery();
		query.setPerPage(10);
		query.setEndpoint(AngularQuery.ENDPOINT_NEWS_TEAM, id.toString());
		let url:string = query.getUrl();
		return this.http
			.get<Team>(url);

	}


	/**
	 * Get a particular team by the ID number.
	 *
	 * @param {number}  id  The team ID to retrieve.
	 * @returns {Observable<Team>} The Observable which will have data.
	 */
	getTeamById(id: number): Observable<Team> {

		// Pass back an empty team object if the ID passed is -1.
		if (-1 === id) {

			let team: Team = new Team({'id': -1, 'title': '', 'shorttitle': '',
				'code': 'NFL', 'team_code': '', 'conference': 'None', 'division': '', 'leagueid': 0});

			return Observable.of(team).delay(500);  // Without the delay, this won't work in some circumstances.

		}

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_TEAM, id.toString());
		let url:string = query.getUrl();

		return this.http
			.get<Team>(url);

	}


	/**
	 * Retrieve an array of Team objects by code.
	 *
	 * @param code   'NFL', 'MLB', etc.
	 * @returns {Observable<Team[]>}
	 */
	getTeamsBySport(code: string): Observable<Team[]> {

		let query:AngularQuery = new AngularQuery();
		query.setPerPage(100);
		query.setEndpoint(AngularQuery.ENDPOINT_TEAM);
		query.addParameter('field', 'code');
		query.addParameter('search', code);
		query.addParameter('order_field', 'title');
		query.addParameter('sort_order', 'asc');
		let url:string = query.getUrl();
		return this.http
			.get<Team[]>(url);

	}


	/**
	 * Save the provided team information.
	 *
	 * @param {string} url    The URL to post to.
	 * @param {string} json   The data as a JSON string.
	 * @return {Observable}  The saved data echoed back.
	 */
	save(url: string, json: string): Observable<Team> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<Team>(url, json, { headers: headers });

	}


	/**
	 * Search for the team and return an Observable.
	 *
	 * @param {string} teamName  The name of the team being searched for.
	 * @param {string} code      The type of team (NFL, MLB, etc.)
	 * @returns {Observable<Team[]>}  An Observable with Teams found.
	 */
	search(teamName: string, code: string = ''): Observable<Team[]> {

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_TEAM);          // Search the team table.
		query.setPerPage(5);                                    // Limit results to 5 entries.
		query.addParameter('field', 'title');                   // Do a search of the 'title' field.
		query.addParameter('search', '%' + teamName + '%');     // Do a 'LIKE' search for the team name.

		if (0 !== code.length) {

			query.addParameter('code', code);

		}

		let url:string = query.getUrl();
		return this.http
			.get<Team[]>(url);

	}

}


// WEBPACK FOOTER //
// ./src/app/services/team/team.service.ts